import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronLeft, CheckCircle2, Circle, AlertCircle, MapPin, Mail, Download, Clock, Car, Coffee, Mic2, Ticket } from 'lucide-react';
import { Link } from 'react-router-dom';
export function ShowDetailPage() {
  const [activeTab, setActiveTab] = useState('Overview');
  const tabs = ['Overview', 'Advance', 'Lineup', 'Finance', 'Docs', 'Timeline'];
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="max-w-6xl mx-auto" data-id="element-4427">
      {/* Header */}
      <div className="mb-6" data-id="element-4428">
        <Link to="/app/shows" className="inline-flex items-center gap-2 text-sm text-textMuted hover:text-textMain transition-colors mb-4" data-id="element-4429">
          <ChevronLeft className="w-4 h-4" data-id="element-4430" /> Back to Shows
        </Link>
        <div className="flex justify-between items-start" data-id="element-4431">
          <div data-id="element-4432">
            <div className="flex items-center gap-3 mb-1" data-id="element-4433">
              <h2 className="text-2xl font-bold" data-id="element-4434">The Empty Bottle</h2>
              <span className="px-2 py-1 bg-primary/10 text-primary text-xs rounded font-medium" data-id="element-4435">
                Advancing
              </span>
            </div>
            <p className="text-textMuted flex items-center gap-1.5" data-id="element-4436">
              Jun 12, 2026 • Chicago, IL
            </p>
          </div>
          <div className="text-right" data-id="element-4437">
            <div className="text-sm text-textMuted" data-id="element-4438">Guarantee</div>
            <div className="text-xl font-bold text-primary" data-id="element-4439">$1,500</div>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="flex gap-6 border-b border-border mb-6 overflow-x-auto" data-id="element-4440">
        {tabs.map(tab => <button key={tab} onClick={() => setActiveTab(tab)} className={`pb-3 text-sm font-medium whitespace-nowrap transition-colors ${activeTab === tab ? 'text-primary border-b-2 border-primary' : 'text-textMuted hover:text-textMain'}`} data-id="element-4441">
            {tab}
          </button>)}
      </div>

      {/* Tab Content */}
      <div className="pb-12" data-id="element-4442">
        {activeTab === 'Overview' && <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-4443">
            <div className="md:col-span-2 space-y-6" data-id="element-4444">
              {/* Venue Info */}
              <div className="bg-surface border border-border rounded-xl p-6" data-id="element-4445">
                <h3 className="text-lg font-semibold mb-4" data-id="element-4446">Venue Details</h3>
                <div className="flex items-start gap-3 mb-6" data-id="element-4447">
                  <MapPin className="w-5 h-5 text-textMuted shrink-0 mt-0.5" data-id="element-4448" />
                  <div data-id="element-4449">
                    <div className="font-medium" data-id="element-4450">1035 N Western Ave</div>
                    <div className="text-textMuted" data-id="element-4451">Chicago, IL 60622</div>
                    <a href="#" className="text-sm text-primary hover:underline mt-1 inline-block" data-id="element-4452">
                      Get Directions
                    </a>
                  </div>
                </div>

                <h4 className="text-sm font-medium text-textMuted uppercase tracking-wider mb-3" data-id="element-4453">
                  Key Contacts
                </h4>
                <div className="space-y-3" data-id="element-4454">
                  <div className="flex items-center justify-between p-3 bg-background border border-border rounded-lg" data-id="element-4455">
                    <div data-id="element-4456">
                      <div className="font-medium text-sm" data-id="element-4457">Dan</div>
                      <div className="text-xs text-textMuted" data-id="element-4458">Talent Buyer</div>
                    </div>
                    <a href="mailto:dan@emptybottle.com" className="p-2 text-textMuted hover:text-primary transition-colors bg-surface rounded-md" data-id="element-4459">
                      <Mail className="w-4 h-4" data-id="element-4460" />
                    </a>
                  </div>
                  <div className="flex items-center justify-between p-3 bg-background border border-border rounded-lg" data-id="element-4461">
                    <div data-id="element-4462">
                      <div className="font-medium text-sm" data-id="element-4463">Mike</div>
                      <div className="text-xs text-textMuted" data-id="element-4464">Production</div>
                    </div>
                    <a href="mailto:mike@emptybottle.com" className="p-2 text-textMuted hover:text-primary transition-colors bg-surface rounded-md" data-id="element-4465">
                      <Mail className="w-4 h-4" data-id="element-4466" />
                    </a>
                  </div>
                </div>
              </div>

              {/* Schedule Snapshot */}
              <div className="bg-surface border border-border rounded-xl p-6" data-id="element-4467">
                <h3 className="text-lg font-semibold mb-4" data-id="element-4468">
                  Schedule Snapshot
                </h3>
                <div className="flex items-center justify-between p-4 bg-background border border-border rounded-lg mb-2" data-id="element-4469">
                  <div className="flex items-center gap-3" data-id="element-4470">
                    <Clock className="w-5 h-5 text-textMuted" data-id="element-4471" />
                    <span className="font-medium" data-id="element-4472">Load-in</span>
                  </div>
                  <span className="font-bold" data-id="element-4473">2:00 PM</span>
                </div>
                <div className="flex items-center justify-between p-4 bg-background border border-border rounded-lg mb-2" data-id="element-4474">
                  <div className="flex items-center gap-3" data-id="element-4475">
                    <Mic2 className="w-5 h-5 text-textMuted" data-id="element-4476" />
                    <span className="font-medium" data-id="element-4477">Soundcheck</span>
                  </div>
                  <span className="font-bold" data-id="element-4478">4:00 PM</span>
                </div>
                <div className="flex items-center justify-between p-4 bg-background border border-border rounded-lg mb-2" data-id="element-4479">
                  <div className="flex items-center gap-3" data-id="element-4480">
                    <Ticket className="w-5 h-5 text-textMuted" data-id="element-4481" />
                    <span className="font-medium" data-id="element-4482">Doors</span>
                  </div>
                  <span className="font-bold" data-id="element-4483">7:00 PM</span>
                </div>
                <div className="flex items-center justify-between p-4 bg-primary/10 border border-primary/20 rounded-lg text-primary" data-id="element-4484">
                  <div className="flex items-center gap-3" data-id="element-4485">
                    <Mic2 className="w-5 h-5" data-id="element-4486" />
                    <span className="font-medium" data-id="element-4487">Set Time</span>
                  </div>
                  <span className="font-bold" data-id="element-4488">9:00 PM</span>
                </div>
              </div>
            </div>

            <div className="space-y-6" data-id="element-4489">
              {/* Lock Status */}
              <div className="bg-surface border border-border rounded-xl p-5" data-id="element-4490">
                <h3 className="text-sm font-semibold text-textMuted uppercase tracking-wider mb-4" data-id="element-4491">
                  Lock Status
                </h3>
                <div className="space-y-4" data-id="element-4492">
                  <div className="flex items-center justify-between" data-id="element-4493">
                    <span className="text-sm font-medium" data-id="element-4494">Contract</span>
                    <CheckCircle2 className="w-5 h-5 text-green-500" data-id="element-4495" />
                  </div>
                  <div className="flex items-center justify-between" data-id="element-4496">
                    <span className="text-sm font-medium" data-id="element-4497">Deposit</span>
                    <CheckCircle2 className="w-5 h-5 text-green-500" data-id="element-4498" />
                  </div>
                  <div className="flex items-center justify-between" data-id="element-4499">
                    <span className="text-sm font-medium" data-id="element-4500">Lineup</span>
                    <div className="flex items-center gap-1.5 text-amber-500 text-sm font-medium" data-id="element-4501">
                      3/4 <AlertCircle className="w-4 h-4" data-id="element-4502" />
                    </div>
                  </div>
                  <div className="pt-4 border-t border-border" data-id="element-4503">
                    <div className="flex items-center justify-between mb-2" data-id="element-4504">
                      <span className="text-sm font-medium" data-id="element-4505">
                        Advance Progress
                      </span>
                      <span className="text-sm text-textMuted" data-id="element-4506">5/7</span>
                    </div>
                    <div className="h-2 bg-background rounded-full overflow-hidden" data-id="element-4507">
                      <div className="h-full bg-primary w-[71%]" data-id="element-4508"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>}

        {activeTab === 'Advance' && <div className="bg-surface border border-border rounded-xl p-6" data-id="element-4509">
            <div className="flex justify-between items-center mb-6" data-id="element-4510">
              <h3 className="text-lg font-semibold" data-id="element-4511">Advance Checklist</h3>
              <button className="px-4 py-2 bg-primary/10 text-primary text-sm font-medium rounded-lg hover:bg-primary/20 transition-colors" data-id="element-4512">
                Send Advance Email
              </button>
            </div>

            <div className="space-y-8" data-id="element-4513">
              {/* Contacts */}
              <div data-id="element-4514">
                <h4 className="text-sm font-semibold text-textMuted uppercase tracking-wider mb-3 flex items-center gap-2" data-id="element-4515">
                  <Mail className="w-4 h-4" data-id="element-4516" /> Contacts
                </h4>
                <div className="space-y-2" data-id="element-4517">
                  <label className="flex items-center gap-3 p-3 bg-background border border-border rounded-lg cursor-pointer hover:border-primary/50 transition-colors" data-id="element-4518">
                    <input type="checkbox" defaultChecked className="w-4 h-4 rounded border-border text-primary focus:ring-primary bg-surface" data-id="element-4519" />
                    <span className="text-sm" data-id="element-4520">Talent buyer confirmed</span>
                  </label>
                  <label className="flex items-center gap-3 p-3 bg-background border border-border rounded-lg cursor-pointer hover:border-primary/50 transition-colors" data-id="element-4521">
                    <input type="checkbox" defaultChecked className="w-4 h-4 rounded border-border text-primary focus:ring-primary bg-surface" data-id="element-4522" />
                    <span className="text-sm" data-id="element-4523">
                      Production contact confirmed
                    </span>
                  </label>
                  <label className="flex items-center gap-3 p-3 bg-background border border-border rounded-lg cursor-pointer hover:border-primary/50 transition-colors" data-id="element-4524">
                    <input type="checkbox" className="w-4 h-4 rounded border-border text-primary focus:ring-primary bg-surface" data-id="element-4525" />
                    <span className="text-sm" data-id="element-4526">Day-of contact confirmed</span>
                  </label>
                </div>
              </div>

              {/* Timing */}
              <div data-id="element-4527">
                <h4 className="text-sm font-semibold text-textMuted uppercase tracking-wider mb-3 flex items-center gap-2" data-id="element-4528">
                  <Clock className="w-4 h-4" data-id="element-4529" /> Timing
                </h4>
                <div className="space-y-2" data-id="element-4530">
                  <label className="flex items-center gap-3 p-3 bg-background border border-border rounded-lg cursor-pointer hover:border-primary/50 transition-colors" data-id="element-4531">
                    <input type="checkbox" defaultChecked className="w-4 h-4 rounded border-border text-primary focus:ring-primary bg-surface" data-id="element-4532" />
                    <span className="text-sm flex-1" data-id="element-4533">Load-in time set</span>
                    <span className="text-xs text-textMuted" data-id="element-4534">2:00 PM</span>
                  </label>
                  <label className="flex items-center gap-3 p-3 bg-background border border-border rounded-lg cursor-pointer hover:border-primary/50 transition-colors" data-id="element-4535">
                    <input type="checkbox" defaultChecked className="w-4 h-4 rounded border-border text-primary focus:ring-primary bg-surface" data-id="element-4536" />
                    <span className="text-sm flex-1" data-id="element-4537">Soundcheck time set</span>
                    <span className="text-xs text-textMuted" data-id="element-4538">4:00 PM</span>
                  </label>
                  <label className="flex items-center gap-3 p-3 bg-background border border-border rounded-lg cursor-pointer hover:border-primary/50 transition-colors" data-id="element-4539">
                    <input type="checkbox" defaultChecked className="w-4 h-4 rounded border-border text-primary focus:ring-primary bg-surface" data-id="element-4540" />
                    <span className="text-sm flex-1" data-id="element-4541">Doors time set</span>
                    <span className="text-xs text-textMuted" data-id="element-4542">7:00 PM</span>
                  </label>
                  <label className="flex items-center gap-3 p-3 bg-background border border-border rounded-lg cursor-pointer hover:border-primary/50 transition-colors" data-id="element-4543">
                    <input type="checkbox" defaultChecked className="w-4 h-4 rounded border-border text-primary focus:ring-primary bg-surface" data-id="element-4544" />
                    <span className="text-sm flex-1" data-id="element-4545">Set time set</span>
                    <span className="text-xs text-textMuted" data-id="element-4546">9:00 PM</span>
                  </label>
                </div>
              </div>

              {/* Logistics */}
              <div data-id="element-4547">
                <h4 className="text-sm font-semibold text-textMuted uppercase tracking-wider mb-3 flex items-center gap-2" data-id="element-4548">
                  <Car className="w-4 h-4" data-id="element-4549" /> Logistics & Hospitality
                </h4>
                <div className="space-y-2" data-id="element-4550">
                  <label className="flex items-center gap-3 p-3 bg-background border border-border rounded-lg cursor-pointer hover:border-primary/50 transition-colors" data-id="element-4551">
                    <input type="checkbox" className="w-4 h-4 rounded border-border text-primary focus:ring-primary bg-surface" data-id="element-4552" />
                    <span className="text-sm" data-id="element-4553">Guest list submitted</span>
                  </label>
                  <label className="flex items-center gap-3 p-3 bg-background border border-border rounded-lg cursor-pointer hover:border-primary/50 transition-colors" data-id="element-4554">
                    <input type="checkbox" defaultChecked className="w-4 h-4 rounded border-border text-primary focus:ring-primary bg-surface" data-id="element-4555" />
                    <span className="text-sm flex-1" data-id="element-4556">
                      Parking/Load-in details confirmed
                    </span>
                    <span className="text-xs text-textMuted" data-id="element-4557">Rear lot</span>
                  </label>
                  <label className="flex items-center gap-3 p-3 bg-background border border-border rounded-lg cursor-pointer hover:border-primary/50 transition-colors" data-id="element-4558">
                    <input type="checkbox" defaultChecked className="w-4 h-4 rounded border-border text-primary focus:ring-primary bg-surface" data-id="element-4559" />
                    <span className="text-sm" data-id="element-4560">Green room access confirmed</span>
                  </label>
                  <label className="flex items-center gap-3 p-3 bg-background border border-border rounded-lg cursor-pointer hover:border-primary/50 transition-colors" data-id="element-4561">
                    <input type="checkbox" className="w-4 h-4 rounded border-border text-primary focus:ring-primary bg-surface" data-id="element-4562" />
                    <span className="text-sm flex-1" data-id="element-4563">
                      Meal buyout confirmed
                    </span>
                    <span className="text-xs text-textMuted" data-id="element-4564">$15/person</span>
                  </label>
                </div>
              </div>
            </div>
          </div>}

        {activeTab === 'Lineup' && <div className="bg-surface border border-border rounded-xl overflow-hidden" data-id="element-4565">
            <div className="p-4 border-b border-border bg-amber-500/10 flex items-start gap-3" data-id="element-4566">
              <AlertCircle className="w-5 h-5 text-amber-500 shrink-0 mt-0.5" data-id="element-4567" />
              <div data-id="element-4568">
                <h4 className="text-sm font-medium text-amber-500 mb-1" data-id="element-4569">
                  Lineup Conflict Detected
                </h4>
                <p className="text-xs text-amber-500/80" data-id="element-4570">
                  Tom Rivera (Drums) has a conflict on June 12. You need to
                  assign a substitute to lock the lineup.
                </p>
                <button className="mt-2 px-3 py-1.5 bg-amber-500 text-background text-xs font-medium rounded hover:bg-amber-600 transition-colors" data-id="element-4571">
                  Assign Substitute
                </button>
              </div>
            </div>
            <table className="w-full text-sm text-left" data-id="element-4572">
              <thead className="bg-background border-b border-border text-textMuted" data-id="element-4573">
                <tr data-id="element-4574">
                  <th className="px-6 py-3 font-medium" data-id="element-4575">Member</th>
                  <th className="px-6 py-3 font-medium" data-id="element-4576">Role</th>
                  <th className="px-6 py-3 font-medium" data-id="element-4577">Status for Jun 12</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-border" data-id="element-4578">
                <tr data-id="element-4579">
                  <td className="px-6 py-4 font-medium" data-id="element-4580">Mark Thompson</td>
                  <td className="px-6 py-4 text-textMuted" data-id="element-4581">Guitar, Vocals</td>
                  <td className="px-6 py-4" data-id="element-4582">
                    <span className="flex items-center gap-1.5 text-green-500" data-id="element-4583">
                      <CheckCircle2 className="w-4 h-4" data-id="element-4584" /> Confirmed
                    </span>
                  </td>
                </tr>
                <tr data-id="element-4585">
                  <td className="px-6 py-4 font-medium" data-id="element-4586">Sarah Chen</td>
                  <td className="px-6 py-4 text-textMuted" data-id="element-4587">Bass</td>
                  <td className="px-6 py-4" data-id="element-4588">
                    <span className="flex items-center gap-1.5 text-green-500" data-id="element-4589">
                      <CheckCircle2 className="w-4 h-4" data-id="element-4590" /> Confirmed
                    </span>
                  </td>
                </tr>
                <tr className="bg-red-500/[0.02]" data-id="element-4591">
                  <td className="px-6 py-4 font-medium" data-id="element-4592">Tom Rivera</td>
                  <td className="px-6 py-4 text-textMuted" data-id="element-4593">Drums</td>
                  <td className="px-6 py-4" data-id="element-4594">
                    <span className="flex items-center gap-1.5 text-red-500" data-id="element-4595">
                      <AlertCircle className="w-4 h-4" data-id="element-4596" /> Conflict
                    </span>
                  </td>
                </tr>
                <tr data-id="element-4597">
                  <td className="px-6 py-4 font-medium" data-id="element-4598">Lisa Park</td>
                  <td className="px-6 py-4 text-textMuted" data-id="element-4599">Keys</td>
                  <td className="px-6 py-4" data-id="element-4600">
                    <span className="flex items-center gap-1.5 text-green-500" data-id="element-4601">
                      <CheckCircle2 className="w-4 h-4" data-id="element-4602" /> Confirmed
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>}

        {activeTab === 'Finance' && <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-4603">
            <div className="space-y-6" data-id="element-4604">
              <div className="bg-surface border border-border rounded-xl p-6" data-id="element-4605">
                <h3 className="text-lg font-semibold mb-4" data-id="element-4606">Show Revenue</h3>
                <div className="space-y-3" data-id="element-4607">
                  <div className="flex justify-between items-center p-3 bg-background border border-border rounded-lg" data-id="element-4608">
                    <span className="text-sm text-textMuted" data-id="element-4609">Guarantee</span>
                    <span className="font-medium" data-id="element-4610">$1,500</span>
                  </div>
                  <div className="flex justify-between items-center p-3 bg-background border border-border rounded-lg" data-id="element-4611">
                    <span className="text-sm text-textMuted" data-id="element-4612">
                      Door Split (Est.)
                    </span>
                    <span className="font-medium text-primary" data-id="element-4613">+$400</span>
                  </div>
                  <div className="flex justify-between items-center p-3 bg-background border border-border rounded-lg" data-id="element-4614">
                    <span className="text-sm text-textMuted" data-id="element-4615">Merch (Est.)</span>
                    <span className="font-medium text-primary" data-id="element-4616">+$350</span>
                  </div>
                  <div className="flex justify-between items-center p-4 bg-surfaceHover rounded-lg border border-border mt-4" data-id="element-4617">
                    <span className="font-semibold" data-id="element-4618">Total Estimated</span>
                    <span className="text-xl font-bold" data-id="element-4619">$2,250</span>
                  </div>
                </div>
              </div>

              <div className="bg-surface border border-border rounded-xl p-6" data-id="element-4620">
                <h3 className="text-lg font-semibold mb-4" data-id="element-4621">Payment Status</h3>
                <div className="space-y-4" data-id="element-4622">
                  <div data-id="element-4623">
                    <div className="flex justify-between text-sm mb-1" data-id="element-4624">
                      <span className="text-textMuted" data-id="element-4625">Deposit Received</span>
                      <span className="font-medium text-green-500" data-id="element-4626">$750</span>
                    </div>
                    <div className="h-2 bg-background rounded-full overflow-hidden" data-id="element-4627">
                      <div className="h-full bg-green-500 w-full" data-id="element-4628"></div>
                    </div>
                  </div>
                  <div data-id="element-4629">
                    <div className="flex justify-between text-sm mb-1" data-id="element-4630">
                      <span className="text-textMuted" data-id="element-4631">
                        Balance Due (Day of)
                      </span>
                      <span className="font-medium text-amber-500" data-id="element-4632">$750</span>
                    </div>
                    <div className="h-2 bg-background rounded-full overflow-hidden" data-id="element-4633">
                      <div className="h-full bg-amber-500 w-0" data-id="element-4634"></div>
                    </div>
                  </div>
                  <div className="pt-4 border-t border-border flex justify-between items-center" data-id="element-4635">
                    <span className="text-sm font-medium" data-id="element-4636">
                      Settlement Status
                    </span>
                    <span className="px-2 py-1 bg-surface border border-border text-xs rounded text-textMuted" data-id="element-4637">
                      Pending Show
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-surface border border-border rounded-xl p-6" data-id="element-4638">
              <h3 className="text-lg font-semibold mb-4" data-id="element-4639">Member Payouts</h3>
              <p className="text-sm text-textMuted mb-4" data-id="element-4640">
                Payouts will be calculated after final settlement.
              </p>

              <div className="space-y-3" data-id="element-4641">
                <div className="flex justify-between items-center p-3 bg-background border border-border rounded-lg opacity-60" data-id="element-4642">
                  <div data-id="element-4643">
                    <div className="font-medium text-sm" data-id="element-4644">Mark Thompson</div>
                    <div className="text-xs text-textMuted" data-id="element-4645">Standard Rate</div>
                  </div>
                  <span className="font-medium" data-id="element-4646">$300</span>
                </div>
                <div className="flex justify-between items-center p-3 bg-background border border-border rounded-lg opacity-60" data-id="element-4647">
                  <div data-id="element-4648">
                    <div className="font-medium text-sm" data-id="element-4649">Sarah Chen</div>
                    <div className="text-xs text-textMuted" data-id="element-4650">Standard Rate</div>
                  </div>
                  <span className="font-medium" data-id="element-4651">$250</span>
                </div>
                <div className="flex justify-between items-center p-3 bg-background border border-border rounded-lg opacity-60" data-id="element-4652">
                  <div data-id="element-4653">
                    <div className="font-medium text-sm" data-id="element-4654">Tom Rivera</div>
                    <div className="text-xs text-textMuted" data-id="element-4655">Standard Rate</div>
                  </div>
                  <span className="font-medium" data-id="element-4656">$275</span>
                </div>
                <div className="flex justify-between items-center p-3 bg-background border border-border rounded-lg opacity-60" data-id="element-4657">
                  <div data-id="element-4658">
                    <div className="font-medium text-sm" data-id="element-4659">Lisa Park</div>
                    <div className="text-xs text-textMuted" data-id="element-4660">Standard Rate</div>
                  </div>
                  <span className="font-medium" data-id="element-4661">$250</span>
                </div>
              </div>
            </div>
          </div>}

        {activeTab === 'Docs' && <div className="bg-surface border border-border rounded-xl overflow-hidden" data-id="element-4662">
            <table className="w-full text-sm text-left" data-id="element-4663">
              <thead className="bg-background border-b border-border text-textMuted" data-id="element-4664">
                <tr data-id="element-4665">
                  <th className="px-6 py-4 font-medium" data-id="element-4666">Document</th>
                  <th className="px-6 py-4 font-medium" data-id="element-4667">Status</th>
                  <th className="px-6 py-4 font-medium" data-id="element-4668">Last Updated</th>
                  <th className="px-6 py-4 text-right" data-id="element-4669">Action</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-border" data-id="element-4670">
                <tr className="hover:bg-surfaceHover transition-colors" data-id="element-4671">
                  <td className="px-6 py-4 font-medium flex items-center gap-2" data-id="element-4672">
                    <FileSignature className="w-4 h-4 text-primary" data-id="element-4673" />{' '}
                    Performance Contract
                  </td>
                  <td className="px-6 py-4" data-id="element-4674">
                    <span className="flex items-center gap-1.5 text-green-500 text-xs font-medium" data-id="element-4675">
                      <CheckCircle2 className="w-3.5 h-3.5" data-id="element-4676" /> Signed
                    </span>
                  </td>
                  <td className="px-6 py-4 text-textMuted" data-id="element-4677">May 15, 2026</td>
                  <td className="px-6 py-4 text-right" data-id="element-4678">
                    <button className="p-2 text-textMuted hover:text-primary transition-colors bg-background rounded-md border border-border" data-id="element-4679">
                      <Download className="w-4 h-4" data-id="element-4680" />
                    </button>
                  </td>
                </tr>
                <tr className="hover:bg-surfaceHover transition-colors" data-id="element-4681">
                  <td className="px-6 py-4 font-medium flex items-center gap-2" data-id="element-4682">
                    <FileText className="w-4 h-4 text-blue-500" data-id="element-4683" /> Technical
                    Rider
                  </td>
                  <td className="px-6 py-4" data-id="element-4684">
                    <span className="flex items-center gap-1.5 text-green-500 text-xs font-medium" data-id="element-4685">
                      <CheckCircle2 className="w-3.5 h-3.5" data-id="element-4686" /> Sent
                    </span>
                  </td>
                  <td className="px-6 py-4 text-textMuted" data-id="element-4687">May 16, 2026</td>
                  <td className="px-6 py-4 text-right" data-id="element-4688">
                    <button className="p-2 text-textMuted hover:text-primary transition-colors bg-background rounded-md border border-border" data-id="element-4689">
                      <Download className="w-4 h-4" data-id="element-4690" />
                    </button>
                  </td>
                </tr>
                <tr className="hover:bg-surfaceHover transition-colors" data-id="element-4691">
                  <td className="px-6 py-4 font-medium flex items-center gap-2" data-id="element-4692">
                    <FileText className="w-4 h-4 text-textMuted" data-id="element-4693" /> W-9 Form
                  </td>
                  <td className="px-6 py-4" data-id="element-4694">
                    <span className="flex items-center gap-1.5 text-green-500 text-xs font-medium" data-id="element-4695">
                      <CheckCircle2 className="w-3.5 h-3.5" data-id="element-4696" /> On File
                    </span>
                  </td>
                  <td className="px-6 py-4 text-textMuted" data-id="element-4697">Jan 10, 2026</td>
                  <td className="px-6 py-4 text-right" data-id="element-4698">
                    <button className="p-2 text-textMuted hover:text-primary transition-colors bg-background rounded-md border border-border" data-id="element-4699">
                      <Download className="w-4 h-4" data-id="element-4700" />
                    </button>
                  </td>
                </tr>
                <tr className="hover:bg-surfaceHover transition-colors opacity-60" data-id="element-4701">
                  <td className="px-6 py-4 font-medium flex items-center gap-2" data-id="element-4702">
                    <DollarSign className="w-4 h-4 text-textMuted" data-id="element-4703" /> Final
                    Invoice
                  </td>
                  <td className="px-6 py-4" data-id="element-4704">
                    <span className="text-xs text-textMuted font-medium" data-id="element-4705">
                      Not Generated
                    </span>
                  </td>
                  <td className="px-6 py-4 text-textMuted" data-id="element-4706">-</td>
                  <td className="px-6 py-4 text-right" data-id="element-4707">
                    <button className="px-3 py-1.5 text-xs font-medium text-textMain bg-background rounded-md border border-border hover:bg-surface transition-colors" data-id="element-4708">
                      Generate
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>}

        {activeTab === 'Timeline' && <div className="bg-surface border border-border rounded-xl p-6" data-id="element-4709">
            <div className="space-y-6 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-border before:to-transparent" data-id="element-4710">
              <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-4711">
                <div className="flex items-center justify-center w-10 h-10 rounded-full border border-border bg-surface shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 shadow text-primary" data-id="element-4712">
                  <CheckCircle2 className="w-4 h-4" data-id="element-4713" />
                </div>
                <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] p-4 rounded-xl border border-border bg-background shadow" data-id="element-4714">
                  <div className="flex items-center justify-between mb-1" data-id="element-4715">
                    <div className="font-bold text-sm" data-id="element-4716">Advance Started</div>
                    <div className="text-xs text-textMuted" data-id="element-4717">May 20, 2026</div>
                  </div>
                  <div className="text-sm text-textMuted" data-id="element-4718">
                    Logistics coordination begun with venue.
                  </div>
                </div>
              </div>

              <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-4719">
                <div className="flex items-center justify-center w-10 h-10 rounded-full border border-border bg-surface shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 shadow text-green-500" data-id="element-4720">
                  <DollarSign className="w-4 h-4" data-id="element-4721" />
                </div>
                <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] p-4 rounded-xl border border-border bg-background shadow" data-id="element-4722">
                  <div className="flex items-center justify-between mb-1" data-id="element-4723">
                    <div className="font-bold text-sm" data-id="element-4724">Deposit Received</div>
                    <div className="text-xs text-textMuted" data-id="element-4725">May 18, 2026</div>
                  </div>
                  <div className="text-sm text-textMuted" data-id="element-4726">
                    $750 deposit confirmed.
                  </div>
                </div>
              </div>

              <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-4727">
                <div className="flex items-center justify-center w-10 h-10 rounded-full border border-border bg-surface shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 shadow text-green-500" data-id="element-4728">
                  <FileSignature className="w-4 h-4" data-id="element-4729" />
                </div>
                <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] p-4 rounded-xl border border-border bg-background shadow" data-id="element-4730">
                  <div className="flex items-center justify-between mb-1" data-id="element-4731">
                    <div className="font-bold text-sm" data-id="element-4732">Contract Signed</div>
                    <div className="text-xs text-textMuted" data-id="element-4733">May 15, 2026</div>
                  </div>
                  <div className="text-sm text-textMuted" data-id="element-4734">
                    Both parties signed the performance agreement.
                  </div>
                </div>
              </div>

              <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-4735">
                <div className="flex items-center justify-center w-10 h-10 rounded-full border border-border bg-surface shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 shadow text-textMuted" data-id="element-4736">
                  <Circle className="w-4 h-4" data-id="element-4737" />
                </div>
                <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] p-4 rounded-xl border border-border bg-background shadow" data-id="element-4738">
                  <div className="flex items-center justify-between mb-1" data-id="element-4739">
                    <div className="font-bold text-sm" data-id="element-4740">Deal Created</div>
                    <div className="text-xs text-textMuted" data-id="element-4741">May 1, 2026</div>
                  </div>
                  <div className="text-sm text-textMuted" data-id="element-4742">
                    Initial inquiry sent to venue.
                  </div>
                </div>
              </div>
            </div>
          </div>}
      </div>
    </motion.div>;
}